"use strict";
/**
 * The Parallel card's quick-add row (ui/market-selection-summary.ts renders
 * it): a tap attaches that sibling as an inverted parallel leg.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickAddSibling = quickAddSibling;
exports.setupParallelQuickAdd = setupParallelQuickAdd;
const sibling_markets_1 = require("../../markets/sibling-markets");
const permissions_1 = require("../../permissions");
const parallel_markets_service_1 = require("../../services/parallel-markets-service");
const state_1 = require("../../state");
function quickAddSibling(marketId, venue) {
    if (!(0, permissions_1.canParallelMarkets)())
        return;
    const { selectedMarket, availableMarkets, selectedEventTicker } = (0, state_1.getState)();
    // Looked up, not trusted from the chip: the event may have moved on since render.
    const market = availableMarkets?.find((m) => m.id === marketId && m.venue === venue);
    if (!selectedMarket || !market)
        return;
    (0, state_1.updateState)({
        parallelMarkets: (0, parallel_markets_service_1.addParallelMarkets)(selectedMarket.id, [(0, sibling_markets_1.siblingLeg)(market, selectedEventTicker ?? "")]),
    });
}
function setupParallelQuickAdd() {
    document.getElementById("parallel-quick-add")?.addEventListener("click", (event) => {
        const chip = event.target.closest(".parallel-quick-add-btn");
        if (chip)
            quickAddSibling(chip.dataset.marketId, chip.dataset.venue);
    });
}
